<template>
  <div>
    <div class="centered-card-container">
      <transition name="slide-fade" mode="out-in">
        <VerifyEmail
          class="centered-card"
          v-if="checkEmail"
          :resend-data="resendData"
        />
        <section class="centered-card" v-else>
          <div class="hero">
            <transition name="from-right" appear>
              <img
                :src="require('../assets/sign-in/ADPUZL-save-time-2.svg')"
                width="1000"
                height="638"
                alt="computer screen with ad and comment bubbles"
              />
            </transition>
            <transition name="from-left" appear>
              <img
                class="man"
                :src="require('../assets/sign-in/ADPUZL-save-time-1.svg')"
                width="1000"
                height="638"
                alt="man leaning back in his chair, glad to be saving time"
              />
            </transition>
          </div>
          <div class="form-container">
            <div class="logo">
              <img
                :src="require('../assets/logo-horizontal.svg')"
                alt="AdPuzl Logo"
                width="230"
                height="60"
              />
            </div>
            <transition name="slide-fade" mode="out-in">
              <router-view @check-email="handleCheckEmail"></router-view>
            </transition>
          </div>
        </section>
      </transition>
    </div>
    <footer class="footer-links">
      <!-- <FooterLinks /> -->
    </footer>
  </div>
</template>

<script>
import VerifyEmail from "../components/VerifyEmail.vue";
export default {
  components: {
    VerifyEmail,
  },
  data: () => ({
    checkEmail: false,
    resendData: null,
  }),
  beforeRouteUpdate(to, from, next) {
    this.checkEmail = false;
    next();
  },
  methods: {
    handleCheckEmail(resData) {
      this.$router.replace({ query: { "confirm-email": "true" } });
      this.resendData = resData;
      this.checkEmail = true;
    },
  },
};
</script>

<style scoped>
.centered-card .hero .man {
  position: absolute;
  left: 0;
  top: 0;
}

.from-right-enter-active,
.from-left-enter-active {
  transition: transform 500ms cubic-bezier(0.5, 1.7, 0.59, 0.92),
    opacity 500ms ease-out;
  transition-delay: 100ms;
  opacity: 1;
}
.from-left-enter-active {
  transition-delay: 400ms;
}
.from-right-enter {
  opacity: 0;
  transform: translateX(100%);
}

.from-left-enter {
  transform: translateX(-100%);
}
</style>
